import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useAppSelector} from '@/hooks';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {SlideshowItemObject} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';
import type {VideoSlideItemObject} from '@PosterWhiteboard/items/slideshow-item/slide-items/video-slide-item.class';

export function useGetKeyFromSelectedVideoSlide<T extends keyof VideoSlideItemObject>(key: T): VideoSlideItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.SLIDESHOW) {
      const itemCopy = item as SlideshowItemObject;
      const slideItem = itemCopy.slides.slidesHashMap[itemCopy.selectedSlideUID];

      if (slideItem.gitype === ITEM_TYPE.VIDEOSLIDE) {
        const textSlideCopy = slideItem as VideoSlideItemObject;
        return textSlideCopy[key];
      }
    }

    return undefined;
  });
}
